import { type UapLoadStatus } from '@ad-engine/communication';
import { context } from '../../services';

export function isRoadblockV2Enabled(): boolean {
	return context.get('state.condition.roadblock.v2') ?? false;
}

export function isUapOrRoadblockV2(action: UapLoadStatus, oldValue: boolean): boolean {
	return isRoadblockV2Enabled() ? action.isLoaded || action.adProduct === 'ruap' : oldValue;
}

export function isNotUapNorRoadblockV2(action: UapLoadStatus, oldValue: boolean): boolean {
	return isRoadblockV2Enabled() ? !action.isLoaded && action.adProduct !== 'ruap' : oldValue;
}
